import React from 'react'
import { connect } from 'react-redux'
import { CLI_CINEMA_CLIENT_ID, CLI_CURRENT_CINEMA_ID, CLI_MULTICINEMA_MODE, PROGRAM_CINEMAS } from '../../../constants/state'
import toJS from '../../../containers/general/toJS'
import getData from '../../../functions/getData'
import ChooseCinema from '../present/ChooseCinema'
import hasPrintSubmenu from '../../../functions/hasPrintSubmenu'
import sortCinemas from '../../../functions/sortCinemas'
import isEmptyObj from '../../../functions/isEmptyObj'
import { Redirect } from 'react-router-dom'
import chooseCinemasActive from '../functions/chooseCinemasActive'
import { printToolChooseCinema } from '../../../actions'

const mapStateToProps = state => ({
    cinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    clientCurrentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    webToPrintRoutes: state.getIn(['wpServerData', 'data', 'data', 'webtoprint']),
    routeData: state.getIn(['wpServerData', 'data', 'data', 'routes'])
})


const mapDispatchToProps = (dispatch, ownProps) => ({
    printChooseCinema: (cinemaId, path) => {
        dispatch(printToolChooseCinema(cinemaId, path))
    }
})

const ChooseCinemaContainer = ({
    cinemas,
    clientCinemaId,
    clientCurrentCinemaId,
    multicinemaMode,
    webToPrintRoutes,
    routeData,
    goBackPath,
    match,
    printChooseCinema,
}) => {
    if(!cinemas || isEmptyObj(cinemas) || !clientCinemaId) {
        return ''
    }

    const basicUrl = match.url

    

    if(chooseCinemasActive(multicinemaMode)) {
        const sortedAlphabeticalCinemas = sortCinemas(clientCinemaId, cinemas)
        const closePagePath = hasPrintSubmenu(webToPrintRoutes, routeData) ? goBackPath: false

        return <ChooseCinema
            cinemaOrder={sortedAlphabeticalCinemas}
            cinemaItems={cinemas}
            basicUrl={basicUrl}
            closePagePath={closePagePath}
            printChooseCinema={printChooseCinema}
        />

    } else {
        return <Redirect 
            to={`${basicUrl}/${clientCurrentCinemaId}`}
        />
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(ChooseCinemaContainer))
